import { render } from "./Features.vue?vue&type=template&id=06836c3a"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\slode\\Documents\\Share\\src\\static-page\\site-vue\\hello-world\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__